import { useEffect } from 'react';

const BLACKLIST = ['/players/', '/login', '/support'];
const blacklistedPage = () => BLACKLIST.some((s) => window.location.pathname.indexOf(s) !== -1);

const STORAGE_KEY = 'advertRememberedSession';

const blocked = () => !!localStorage.getItem(STORAGE_KEY) || blacklistedPage();

const rememberSessionOnSubmit = (e: Event) => {
  if ((e.target as HTMLFormElement).dataset.adverts) {
    localStorage.setItem(STORAGE_KEY, 'true');
  }
};

const rememberSessionOnClickButton = (e: MouseEvent) => {
  const form = (e.target as HTMLButtonElement).closest('form');
  const targetType = (e.target as HTMLButtonElement).attributes.getNamedItem('type');
  if (targetType?.value === 'submit' && form?.dataset?.adverts) {
    localStorage.setItem(STORAGE_KEY, 'true');
  }
};

const useBlockedPages = (): boolean => {
  useEffect(() => {
    document.addEventListener('submit', rememberSessionOnSubmit);
    document.addEventListener('click', rememberSessionOnClickButton);

    return () => {
      document.removeEventListener('submit', rememberSessionOnSubmit);
      document.removeEventListener('click', rememberSessionOnClickButton);
    };
  }, []);

  return blocked();
};

export default useBlockedPages;
